module.exports = __webpack_public_path__ + "img/img3.fe11bef3.jpg";